export default __webpack_public_path__ + "static/media/sound-unmuted.55eadf06.svg";